import React, { useState } from 'react';
import { AdSlot } from 'react-dfp';
import PropTypes from 'prop-types';
import { BANNER_LOADING, BANNER_EMPTY, BANNER_LOADED } from '../../constants';
import Wrapper from '../Wrapper';

const AdSlotRender = ({
  shouldShowBanner,
  sizeMapping,
  sizeId,
  parsedAdunit,
  parsedSizes,
  modifiers,
  targetingArguments
}) => {
  const [{ loadingStatus = BANNER_LOADING, minHeight }, setLoadingStatus] = useState({});

  const bannerClass = `banner-${sizeId}`;

  const styles =
    loadingStatus === BANNER_LOADING &&
    sizeMapping
      .map(({ sizes: styleSizes, viewport: [minWidth] }) => {
        const minimumHeight = Math.min(...styleSizes.map(([, height]) => height));
        return `@media(min-width:${minWidth}px){.${bannerClass}{min-height:${minimumHeight}px;}`;
      })
      .sort();
  const className = `ad-slot ad-slot-${loadingStatus} ${bannerClass}`;
  const newModifers = `${modifiers} banner-${loadingStatus}`;
  return (
    <Wrapper className="banner" modifiers={newModifers}>
      {styles && <style>{styles.join('\n')}</style>}
      <div className={className} style={{ minHeight }} data-testid="ad-slot">
        {shouldShowBanner && (
          <AdSlot
            adUnit={parsedAdunit}
            sizes={parsedSizes}
            targetingArguments={targetingArguments}
            sizeMapping={sizeMapping}
            onSlotRender={slotData => {
              const {
                event: { isEmpty, size }
              } = slotData;
              const slotHeight = size && size.length ? size[1] : undefined;
              const newLoadingStatus = isEmpty ? BANNER_EMPTY : BANNER_LOADED;
              setLoadingStatus({ loadingStatus: newLoadingStatus, minHeight: slotHeight });
            }}
          />
        )}
      </div>
    </Wrapper>
  );
};

AdSlotRender.propTypes = {
  shouldShowBanner: PropTypes.bool.isRequired,
  sizeMapping: PropTypes.array.isRequired,
  sizeId: PropTypes.string.isRequired,
  parsedAdunit: PropTypes.string.isRequired,
  parsedSizes: PropTypes.array,
  modifiers: PropTypes.string,
  targetingArguments: PropTypes.object.isRequired
};

AdSlotRender.defaultProps = {
  parsedSizes: null,
  modifiers: ''
};

export default AdSlotRender;
